import { Component, type ReactNode } from 'react';

interface Props {
  /** Rendered instead of the children after an error; gets a reset callback. */
  fallback: (reset: () => void) => ReactNode;
  children: ReactNode;
}

/**
 * Keeps a rendering failure local. Never logs message content: only the
 * error name reaches the console (no conversation text or tokens).
 */
export class ErrorBoundary extends Component<Props, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(error: unknown) {
    console.error('UI error', error instanceof Error ? error.name : typeof error);
  }

  reset = () => this.setState({ failed: false });

  override render() {
    return this.state.failed ? this.props.fallback(this.reset) : this.props.children;
  }
}
